export default "__VITE_ASSET__93192427__"